import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDataService } from '../services/user-data.service';
import { SubscriptionService } from '../services/subscription.service';
import { Permission } from '../interfaces/payment-interfaces';

export const dashboardGuard: CanActivateFn = async (route, state) => {
  const userData = inject(UserDataService);
  const router = inject(Router);
  const subscriptionService = inject(SubscriptionService);

  if (!userData.getUser()) {
    // Load user data
    try {
      await userData.loadUserData();
    } catch (error) {
      router.navigate(['/auth/signup']);
      return false;
    }
  }

  const user = userData.getUser();
  const membership = user?.membership;

  if (!membership) {
    return false;
  }

  if (!user || !user.is_active || !subscriptionService.membershipHasPermission(membership, Permission.VIEW_DASHBOARD, true)) {
    router.navigate(['/invoice'], { queryParams: route.queryParams });
    return false;
  }
  return true;
};
